import React, { useContext, useEffect } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { RouteComponentProps } from '@reach/router';

import { GlobalContext } from '../../store';

import Notification from '../Notification/Notification';
import { AdminHeader } from './AdminHeader/AdminHeader';
import { PlayerHeader } from './PlayerHeader/PlayerHeader';
import { isAdmin } from './Utils/isAdmin';

interface IProps extends RouteComponentProps {
  clubId: number;
  eventId: number | undefined;
}

export const Header = (props: IProps) => {
  const { clubId, eventId, location } = props;

  const {
    actions: {
      adminClubs: { all: getAllAdminClubs },
      user: { getOrRetrieve: getOrRetrieveUser },
      seasons: { get: getSeasons },
      pages: { get: getPages }
    },
    loader
  } = useContext(GlobalContext);

  useEffect(() => {
    const retrieval = async () => {
      if (isAdmin(location)) {
        await getAllAdminClubs();
      }

      await getOrRetrieveUser();
    };

    retrieval().catch();
  }, []);

  useEffect(() => {
    const retrieval = async () => {
      if (clubId) {
        const admin = isAdmin(props.location);

        getSeasons(Number(clubId), false, admin).catch();
        getPages(clubId, false, admin);
      }
    };

    retrieval().catch();
  }, [clubId]);

  return (
    <header className="header">
      <Notification />

      {isAdmin(location) ? (
        <AdminHeader clubId={clubId} eventId={eventId} />
      ) : (
        <PlayerHeader clubId={clubId} />
      )}

      <div className={`loading-modal ${loader.activeRequests > 0 ? '' : '-hidden'}`}>
        <CircularProgress className="loading" color="secondary" />
      </div>
    </header>
  );
};
